// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"1cef71d4","384":"a68e8967","577":"9445c76f","744":"343314e2","849":"be7fafe6","930":"457a32a7","971":"607853d4"}[chunkId] + ".chunk.css";
};